import React from 'react';
import { Row, Col } from 'react-bootstrap';

const AsideColorLegend = ({ color, name }) => {
  return (
    <Row className="my-2 ">
      <Col xs={2} className="p-0">
        <div className="rounded p-2" style={{ backgroundColor: color }}></div>
      </Col>
      <Col xs={10}>{name}</Col>
    </Row>
  )
}

export default AsideColorLegend;